import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageLoader = () => {
    // Start with true to show loader instantly
    const [loading, setLoading] = useState(() => {
        // Check immediately if we should show loader
        const isHomeRoute = window.location.pathname === '/';
        if (isHomeRoute) {
            sessionStorage.setItem('hasNavigated', 'true');
            return false;
        }

        // Check if user came from SPA navigation (within same session without refresh)
        // If this flag doesn't exist, it means page was refreshed (flag cleared on unload)
        const hasNavigated = sessionStorage.getItem('hasNavigated');

        // Show loader if flag doesn't exist (meaning page was refreshed or first load)
        return !hasNavigated;
    });

    const location = useLocation();

    useEffect(() => {
        // Only proceed if loader is showing
        if (!loading) return;

        // Mark that we've navigated (to prevent showing on SPA navigation)
        sessionStorage.setItem('hasNavigated', 'true');

        // Hide loader after delay
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500);

        return () => clearTimeout(timer);
    }, []); // Empty dependency array - only run once on mount

    useEffect(() => {
        // Clear the flag on page unload (refresh/close)
        const handleUnload = () => {
            sessionStorage.removeItem('hasNavigated');
        };

        window.addEventListener('beforeunload', handleUnload);

        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);

    if (1 != 1) return null;

    return (
        <div className="page-loader">
            <div className="loader-content">
                <img src="/images/b.png" alt="Logo" className="loader-logo" />
                {/* <div className="loader-spinner">
                    <div className="spinner-circle"></div>
                </div>
                <p className="loader-text">Loading...</p> */}
            </div>
        </div>
    );
};

export default PageLoader;
